module.exports = __webpack_public_path__ + "static/img/contacts.8f15fec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top/contacts.png
// module id = jYDR
// module chunks = 24